import { useTranslation } from 'react-i18next';

export default function WhyGrows() {
  const { t } = useTranslation();

  const factors = [
    { icon: 'ri-store-line', titleKey: 'why_f1_title', descKey: 'why_f1_desc', statKey: 'why_f1_stat', labelKey: 'why_f1_label' },
    { icon: 'ri-seedling-line', titleKey: 'why_f2_title', descKey: 'why_f2_desc', statKey: 'why_f2_stat', labelKey: 'why_f2_label' },
    { icon: 'ri-bread-line', titleKey: 'why_f3_title', descKey: 'why_f3_desc', statKey: 'why_f3_stat', labelKey: 'why_f3_label' },
    { icon: 'ri-inbox-line', titleKey: 'why_f4_title', descKey: 'why_f4_desc', statKey: 'why_f4_stat', labelKey: 'why_f4_label' },
    { icon: 'ri-bar-chart-line', titleKey: 'why_f5_title', descKey: 'why_f5_desc', statKey: 'why_f5_stat', labelKey: 'why_f5_label' },
  ];

  return (
    <section id="about" className="py-16 md:py-28 bg-[#0d1117]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/20 rounded-full px-4 py-1.5 mb-4">
            <i className="ri-time-line text-yellow-400 text-sm"></i>
            <span className="text-yellow-400 text-xs font-semibold uppercase tracking-wide">{t('why_badge')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-black text-white mb-4">
            {t('why_title_1')} <span className="text-yellow-400">{t('why_title_2')}</span>
          </h2>
          <p className="text-white/50 text-sm md:text-base max-w-2xl mx-auto">{t('why_subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {factors.map((f) => (
            <div key={f.titleKey} className="group relative bg-white/5 border border-white/10 rounded-xl p-4 md:p-5 flex flex-col gap-4 hover:border-yellow-500/50 hover:-translate-y-1 transition-all duration-300 cursor-default">
              <div className="absolute left-0 top-6 bottom-6 w-0.5 bg-yellow-500/30 group-hover:bg-yellow-400 rounded-full transition-colors duration-300"></div>
              <div className="w-10 h-10 flex items-center justify-center bg-yellow-500/10 rounded-lg">
                <i className={`${f.icon} text-yellow-400 text-xl`}></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-sm mb-1.5">{t(f.titleKey)}</h3>
                <p className="text-white/50 text-xs leading-relaxed">{t(f.descKey)}</p>
              </div>
              <div className="mt-auto">
                <div className="text-yellow-400 font-black text-xl">{t(f.statKey)}</div>
                <div className="text-white/40 text-xs">{t(f.labelKey)}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 bg-gradient-to-r from-yellow-900/20 via-yellow-800/10 to-yellow-900/20 border border-yellow-500/20 rounded-2xl p-6 md:p-8 text-center">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
            <div>
              <div className="text-yellow-400 font-black text-3xl md:text-4xl">{t('why_stat1_val')}</div>
              <div className="text-white/50 text-sm mt-1">{t('why_stat1_label')}</div>
            </div>
            <div className="hidden md:block w-px h-12 bg-white/10"></div>
            <div className="max-w-md text-center md:text-left">
              <p className="text-white font-semibold text-sm md:text-base mb-1">
                {t('why_text')} <strong className="text-yellow-400">{t('why_wheat')}</strong>.
              </p>
              <p className="text-white/40 text-xs">{t('why_disclaimer')}</p>
            </div>
            <div className="hidden md:block w-px h-12 bg-white/10"></div>
            <div>
              <div className="text-yellow-400 font-black text-3xl md:text-4xl">{t('why_stat2_val')}</div>
              <div className="text-white/50 text-sm mt-1">{t('why_stat2_label')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
